import { ImageSmall } from "@wix/wix-ui-icons-common";
import { pluginFigure } from "./../plugin-figure";
import { IMAGE_TYPE, TIPTAP_IMAGE_TYPE } from "./../ricos-content";
import { quickActionsModalSections, RicosPluginToolbarNames } from "./../ricos-types";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common";
import { DEFAULTS } from "./consts";
import { imageConverter } from "./converter/image-converter";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { handleImageUpload } from "./handle-image-upload";
import { Settings } from "./settings/settings";
import { imageTiptapExtension } from "./tiptap/image-tiptap-extension";
const pluginImage = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: IMAGE_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [imageConverter],
    tiptapExtensions: [imageTiptapExtension],
    toolbar: {
      names: [RicosPluginToolbarNames.IMAGE],
      getButtons: (config2, services) => getToolbarButtons(config2, services),
      resolveReferenceElement: (tiptapEditor) => {
        const startNodePos = tiptapEditor.state.selection.$from;
        if (startNodePos.nodeAfter?.type.name !== TIPTAP_IMAGE_TYPE) {
          return null;
        }
        return tiptapEditor.view.nodeDOM(startNodePos.pos - 1);
      }
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    getQuickActions: ({ pluginServices, config: config2 }) => [
      {
        id: "image",
        title: "QuickActionsPlugin_ActionTitle_Image",
        icon: ImageSmall,
        section: quickActionsModalSections.Media,
        tags: ["photo", "picture", "graphic", "visual", "illustration"],
        command: ({ publicCommands, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          handleImageUpload({ services: pluginServices, config: config2, publicCommands });
        }
      }
    ],
    __exports: {
      SettingsModal: Settings
    },
    dependencies: [pluginFigure]
  };
};
export {
  pluginImage
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
